import { SHOW_CUSTOM_NOTIFICATION, HIDE_CUSTOM_NOTIFICATION } from './actionTypes';

/**
 * Queues a notification for display.
 *
 * @param {Object} props - The props needed to show the custom notification component.
 * automatically being hidden.
 * @returns {{
 *     type: SHOW_NOTIFICATION,
 *     props: Object,
 *     component: React$Element,
 *     id: string,
 *     timeout: number
 * }}
 */
export function showCustomNotification(props, component, id, timeout: ?number) {
    return {
        type: SHOW_CUSTOM_NOTIFICATION,
        props,
        component,
        id,
        timeout
    };
}


/**
 * Queues a notification for display.
 *
 * @param {Object} props - The props needed to show the custom notification component.
 * automatically being hidden.
 * @returns {{
 *     type: HIDE_CUSTOM_NOTIFICATION,
 * }}
 */
export function hideCustomNotification() {
    return {
        type: HIDE_CUSTOM_NOTIFICATION
    };
}
